// Firebase Configuration
export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Firestore Collections
export const COLLECTIONS = {
  TASKS: 'tasks',
  CALENDAR_SLOTS: 'calendar_slots',
  USER_STATS: 'user_stats',
  REWARDS: 'rewards',
  USER_REWARDS: 'user_rewards',
  USER_PROFILES: 'user_profiles',
  CREDIT_APPROVERS: 'credit_approvers',
  REDEEMED_REWARDS: 'redeemed_rewards',
} as const;

// Task Priorities
export const TASK_PRIORITIES = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
} as const;

// Task Categories
export const TASK_CATEGORIES = {
  WORK: 'Work',
  PERSONAL: 'Personal',
  HEALTH: 'Health',
  EDUCATION: 'Education',
  FINANCE: 'Finance',
  OTHER: 'Other',
} as const;

// Credit Values
export const CREDIT_VALUES = {
  SMALL: 100,
  MEDIUM: 250,
  LARGE: 500,
  EXTRA_LARGE: 1000,
} as const;

// UI Constants
export const UI = {
  ANIMATION_DURATION: 0.3,
  HOVER_SCALE: 1.05,
  TAP_SCALE: 0.95,
  COLORS: {
    PRIMARY: '#F57C00',
    PRIMARY_DARK: '#E65100',
    SUCCESS: '#4CAF50',
    ERROR: '#F44336',
    WARNING: '#FF9800',
    INFO: '#2196F3',
  },
} as const;

// Default Values
export const DEFAULTS = {
  TASK_DURATION: 30, // minutes
  TASK_CREDITS: 100,
  TASK_PRIORITY: TASK_PRIORITIES.MEDIUM,
  TASK_CATEGORY: TASK_CATEGORIES.OTHER,
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  AUTHENTICATION_REQUIRED: 'Please sign in to continue',
  TASK_CREATION_FAILED: 'Failed to create task. Please try again.',
  TASK_UPDATE_FAILED: 'Failed to update task. Please try again.',
  TASK_DELETION_FAILED: 'Failed to delete task. Please try again.',
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
} as const;

// Success Messages
export const SUCCESS_MESSAGES = {
  TASK_CREATED: 'Task created successfully!',
  TASK_UPDATED: 'Task updated successfully!',
  TASK_DELETED: 'Task deleted successfully!',
  TASK_COMPLETED: 'Task completed! Great job!',
} as const; 